import type { MarketInfo } from "domain/synthetics/markets";
import type { Token } from "domain/tokens";

export function getChartTokenSelectorFavoriteAddress(token: Token, marketInfo?: MarketInfo): string {
  return marketInfo?.marketTokenAddress ?? token.address;
}
